import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { styled } from '@this/constants/themes';
import type SuppliedItem from '@this/domain/supplied_item/supplied_item2';
import OrderItemSupplierItemSelectList from './order_item_supplier_item_select_list';

interface Props {
  suppliedItems: SuppliedItem[];
  suppliedItemId: number | undefined;
  onSelect: (i: number) => void;
}

const OrderItemSupplierItemSelect: React.FC<Props> = ({ suppliedItems, suppliedItemId, onSelect }) => {
  const [showList, setShowList] = useState(false);
  // 発券方法の選択でsuppliedItemIdが変更されたときに、描画がずれないようにする
  // suppliedItemIdの伝搬：発券方法の選択 → TransportElement → OrderItemOriginalPrice → MobXの再レンダー → OrderItemSupplierItemSelect
  const suppliedItem = useMemo(
    () => suppliedItems.find(s => s.id === suppliedItemId) || null,
    [suppliedItemId, suppliedItems]
  );

  const handleSelect = (selected: number) => {
    setShowList(false);
    onSelect(selected);
  };

  const description = (s: SuppliedItem): string => {
    return `(${s.supplierCode})${s.supplierName} (${s.code})${s.name}`;
  };

  return (
    <SelectSearch>
      <SuppleidItemText onClick={() => setShowList(!showList)} data-testid="supplied-item-selector">
        {suppliedItem ? description(suppliedItem) : ''}
      </SuppleidItemText>
      {showList && (
        <OrderItemSupplierItemSelectList
          onSelect={id => handleSelect(id)}
          suppliedItems={suppliedItems}
          data-testid="supplied-item-list"
        />
      )}
    </SelectSearch>
  );
};

const SelectSearch = styled.div`
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-left: 10px;
  -webkit-box-flex: 50;
  flex-grow: 50;
  min-width: 120px;
`;

const SuppleidItemText = styled.p`
  min-height: 20px;
  background: ${props => props.theme.fieldBgColor};
  line-height: 20px;
  padding: 0 10px;
  cursor: pointer;
  border: 2px solid #eee;
`;

export default OrderItemSupplierItemSelect;
